<template>
  <div class="table">
    <div class="container">
      <div>
        <p class="icon-jujue closeBtn" @click="routerBack"></p>
      </div>
      <el-row class="btn" type="flex" justify="start" align="middle">
        <!-- // 保存按钮functionCode一致且isEdit且id一致 -->
        <el-button type="primary" @click="onSaveClick" v-if="!isDisabled&&(basicForm.latestInspectId==basicForm.inspectId)&&isEdit" v-acl="NUTRITION_INSPECT_SUBMIT" :disabled="isSaDisabled" :loading="isSaLoading">保存</el-button>
        <el-button type="primary" @click="onSubmit" v-if="!isDisabled&&(basicForm.latestInspectId==basicForm.inspectId)&&isSubmit" v-acl="NUTRITION_INSPECT_SUBMIT" :disabled="isSubDisabled" :loading="isSubLoading">提交</el-button>
        <el-button type="primary" @click="onEdit" v-if="!isDisabled&&(basicForm.latestInspectId!=basicForm.inspectId)&&isSubmit" v-acl="NUTRITION_INSPECT_SUBMIT">编辑最新数据</el-button>
      </el-row>
      <div class="box">
        <el-row>
          <div class="info_box_title">
            <p class="line"></p>
            <p class="info_title">基本信息</p>
          </div>
        </el-row>
        <el-form :model="basicForm" ref="basicForm" :rules="rules" label-position="right" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="检测窗口期" prop="windowTime">
                <el-input v-model="basicForm.windowTime" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="版本" prop="versionText">
                <el-input v-model="basicForm.versionText" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="fiveBitCode">
                <el-input v-model="basicForm.fiveBitCode" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品中文名称" prop="describe">
                <el-input v-model="basicForm.describe" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="产品英文名称" prop="fiveBitCodeName">
                <el-input v-model="basicForm.fiveBitCodeName" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结算单位名称" prop="supplierName">
                <el-input v-model="basicForm.supplierName" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工厂名称" prop="facilityName">
                <el-input v-model="basicForm.facilityName" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Category2" prop="categoryLevel2Code">
                <el-select v-model="basicForm.categoryLevel2Code" disabled style="width:100%">
                  <el-option v-for="item in categoryList2" :label="item.name" :value="item.code" :key="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="Category3" prop="categoryLevel3Code">
                <el-select v-model="basicForm.categoryLevel3Code" disabled style="width:100%">
                  <el-option v-for="item in categoryList3" :label="item.name" :value="item.code" :key="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="检测实验室" prop="labCodeText">
                <el-input v-model="basicForm.labCodeText" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="烹饪方式" prop="cookCodeText">
                <el-input v-model="basicForm.cookCodeText" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="COA NO." prop="coaNo">
                <el-input v-model="basicForm.coaNo" :disabled="!isEdit" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="提交日期" prop="cqsSubmitDate">
                <el-date-picker v-model="basicForm.cqsSubmitDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" disabled style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="检测日期" prop="labSubmitDate">
                <el-date-picker v-model="basicForm.labSubmitDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" disabled style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="更新人" prop="updateByName">
                <el-input v-model="basicForm.updateByName" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="更新日期" prop="updateDate">
                <el-date-picker v-model="basicForm.updateDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" disabled style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="状态" prop="inspectStatusText">
                <el-input v-model="basicForm.inspectStatusText" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="box">
        <el-row>
          <div class="info_box_title">
            <p class="line"></p>
            <p class="info_title">Nutrition明细</p>
          </div>
        </el-row>
        <el-row v-show="!isDisabled&&(basicForm.latestInspectId===basicForm.inspectId)">
          <el-form :model="detailForm" ref="detailForm">
            <el-table :data="detailForm.currentDetailList" ref="myTable" max-height="425" border stripe style="width: 100%">
              <el-table-column v-for="(item,index) in detailForm.tableHeaderList" :prop="item.prop" :label="item.label" min-width="150" :key="index" :render-header="(h,obj) =>renderHeader(h,obj,item)">
                <template slot-scope="scope">
                  <el-form-item :prop="`currentDetailList.${scope.$index}.`+`${item.prop}`" :rules="item.required?[{ required: true, message: '请输入*', trigger: ['blur', 'change']}]:''">
                    <span v-if="item.prop=='windowTime'||item.prop=='version'">{{scope.row[item.prop]}}</span>
                    <el-input v-else v-model="scope.row[item.prop]" @input="propInput(scope.row,item.prop,$event)" style="width:100%"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-row>
        <el-row v-show="isDisabled||(basicForm.latestInspectId!==basicForm.inspectId)">
          <el-form :model="detailForm">
            <el-table :data="detailForm.currentDetailList" :cell-class-name="cellClassName" ref="myTable" max-height="425" border stripe style="width: 100%">
              <el-table-column v-for="(item,index) in detailForm.tableHeaderList" :prop="item.prop" :label="item.label" min-width="150" :key="index">
                <template slot-scope="scope">
                  <el-tooltip v-if="scope.row[item.prop]&&scope.row[item.prop+'_gapReason']" effect="dark" :content="scope.row[item.prop+'_gapReason']" placement="top">
                    <p class="nutrition_p">{{scope.row[item.prop]}}</p>
                  </el-tooltip>
                  <p class="nutrition_p" v-else>
                    <span>{{scope.row[item.prop]}}</span>
                  </p>
                  <p class="nutrition_p_span" v-if="scope.row[item.prop+'_alertFlag']=='Y'&&scope.row[item.prop+'_gapPercentPreWindow']">
                    <i :class="Number(scope.row[item.prop+'_gapPercentPreWindow'])>0?'el-icon-top':'el-icon-bottom'"></i>
                    <span v-if="Number(scope.row[item.prop+'_gapPercentPreWindow'])>0">{{scope.row[item.prop+'_gapPercentPreWindow']+'%'}}</span>
                    <span v-if="Number(scope.row[item.prop+'_gapPercentPreWindow'])<0">{{Math.abs(scope.row[item.prop+'_gapPercentPreWindow'])+'%'}}</span>
                  </p>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-row>
      </div>
      <div class="box">
        <el-row>
          <div class="info_box_title">
            <p class="line"></p>
            <p class="info_title">Nutrition历史参考明细</p>
          </div>
        </el-row>
        <el-row>
          <el-table :data="historyWindowDetailList" :cell-class-name="cellClassName" ref="refTable" max-height="425" border stripe style="width: 100%">
            <el-table-column v-for="(item,index) in detailForm.tableHeaderList" :prop="item.prop" :label="item.label" min-width="150" :key="index">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row[item.prop]&&scope.row[item.prop+'_gapReason']" effect="dark" :content="scope.row[item.prop+'_gapReason']" placement="top">
                  <p class="nutrition_p">{{scope.row[item.prop]}}</p>
                </el-tooltip>
                <p class="nutrition_p" v-else>
                  <el-button type="text" v-if="item.prop=='windowTime'" @click="goToDetail(scope.row)">{{scope.row[item.prop]}}</el-button>
                  <span v-else>{{scope.row[item.prop]}}</span>
                </p>
                <p class="nutrition_p_span" v-if="scope.row[item.prop+'_alertFlag']=='Y'&&scope.row[item.prop+'_gapPercentPreWindow']">
                  <i :class="Number(scope.row[item.prop+'_gapPercentPreWindow'])>0?'el-icon-top':'el-icon-bottom'"></i>
                  <span>{{Math.abs(scope.row[item.prop+'_gapPercentPreWindow'])+'%'}}</span>
                </p>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>
      <div class="box">
        <el-row>
          <el-tabs type="border-card">
            <el-tab-pane label="附件上传">
              <el-row class="action-btn-row">
                <el-button size="mini" class="btn" type="primary" @click="onUploadFile" v-if="!isDisabled&&basicForm.latestInspectId==basicForm.inspectId">上传</el-button>
              </el-row>
              <el-table :data="fileTableData" ref="fileTable" max-height="326px" border size="small" style="width: 100%">
                <el-table-column label="序号" type="index" min-width="50px"></el-table-column>
                <el-table-column label="附件类型" prop="attachmentTypeText" show-overflow-tooltip min-width="100px">
                  <!-- <template slot-scope="scope">
                    <ic-select v-model="scope.row.seq" table="TT_NUTR_INSPECT" field="ATTACHMENT_TYPE" disabled style="width:100%"></ic-select>
                  </template> -->
                </el-table-column>
                <el-table-column label="附件名称" prop="documentName" show-overflow-tooltip min-width="180px">
                  <template slot-scope="scope">
                    <el-button type="text" @click="onDownload(scope.row)" v-if="scope.row.tmDocumentId">{{scope.row.documentName}}</el-button>
                    <span v-else>{{scope.row.documentName}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="上传人" prop="uploadBy" show-overflow-tooltip min-width="100px"></el-table-column>
                <el-table-column label="上传时间" prop="uploadTime" show-overflow-tooltip min-width="100px"></el-table-column>
                <el-table-column label="操作" min-width="120px">
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="onDeleteFile(scope.$index,scope.row)" v-if="!isDisabled&&basicForm.latestInspectId==basicForm.inspectId&&scope.row.canOperation" style="padding:1px!important;"><i class="el-icon-delete"></i></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="变更信息">
              <el-row>
                <el-col v-for="(item,index) in changeVersionList" :key="index">
                  <el-form label-position="right" label-width="120px" class="searchForm">
                    <el-row>
                      <div class="info_box_title">
                        <p class="line"></p>
                        <p class="info_title">修订版本 {{item[0].version}}</p>
                      </div>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="8">
                        <el-form-item label="变更日期" prop="updateDate">
                          <el-date-picker v-model="item[0].updateDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" disabled style="width:100%"></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="变更人" prop="updateByName">
                          <el-input v-model="item[0].updateByName" disabled style="width:100%"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="修改备注" prop="updateReason">
                          <el-tooltip class="item" effect="dark" :content="item[0].updateReason" placement="top-start" v-if="item[0].updateReason&&item[0].updateReason.length>50">
                            <el-input v-model="item[0].updateReason" :rows="1" style="width:100%;" type="textarea" maxlength="100" show-word-limit disabled></el-input>
                          </el-tooltip>
                          <el-input v-model="item[0].updateReason" v-else :rows="1" style="width:100%;" type="textarea" maxlength="100" show-word-limit disabled></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                  <el-table :data="item" max-height="425" :cell-class-name="cellClassName1" border stripe style="width: 100%">
                    <el-table-column v-for="(item,index) in detailForm.tableHeaderList" :prop="item.prop" :label="item.label" min-width="150" :key="index"></el-table-column>
                  </el-table>
                  <el-divider></el-divider>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="操作日志">
              <el-table :data="operationLogList" max-height="425" border stripe style="width: 100%">
                <el-table-column prop="createDate" label="操作时间" min-width="100"></el-table-column>
                <el-table-column prop="creater" label="操作人" min-width="100"></el-table-column>
                <el-table-column prop="describe" label="操作描述" min-width="300"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </div>
      <el-dialog title="附件上传" :visible.sync="dialogUploadFileVisible" width="30%" :close-on-click-modal="false" @close="onCloseUploadFile" class="fpa">
        <el-form ref="fileForm" :model="fileForm" :rules="filesRules" label-width="100px">
          <el-form-item prop="seq" label="附件类型">
            <el-select v-model="fileForm.seq" style="width:100%">
              <el-option v-for="item in typeLists" :key="item.code" :label="item.chineseValue" :value="item.code">
                <span style="color:red" v-if="item.code=='INSPECT_ATTACHMENT_TYPE_002'||item.code=='INSPECT_ATTACHMENT_TYPE_001'">*</span>
                <span>{{ item.chineseValue }}</span>
              </el-option>
            </el-select>
            <!-- <ic-select v-model="fileForm.seq" table="TT_NUTR_INSPECT" field="ATTACHMENT_TYPE" clearable style="width:100%"></ic-select> -->
          </el-form-item>
          <el-form-item prop="files" label="选择文件">
            <el-upload ref="upload" name="file" action="" :http-request="httpRequest" :before-upload="beforeUpload" :show-file-list="false">
              <el-input v-model="fileForm.files" readonly style="width:100%;">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </el-upload>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="uploadClick">上传</el-button>
          <el-button size="mini" class="btn" @click="onCloseUploadFile">关闭</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="修改备注" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" @close="onClose" class="fpa">
        <el-form ref="updateForm" :model="updateForm" label-width="100px">
          <el-form-item label="修改备注" prop="updateReason" :rules="{required: true, message: '修改备注不能为空', trigger: 'blur'}">
            <el-input v-model="updateForm.updateReason" type="textarea" :rows="4" maxlength="1000" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="onSave" :disabled="isCDisabled" :loading="isCLoading">确认</el-button>
          <el-button size="mini" class="btn" @click="onClose">取消</el-button>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import nutriApi from "@/api/Nutrition/index";
import { apiService } from "@/api/material/material-master-data";
import { fileService } from "@/api/common/file-utils"
import IcSelect from "@/components/common/icSelect";
import { inputChoiceService } from "@/api/common/input-choice";
export default {
  components: { IcSelect },
  data() {
    var validatePass2 = (rule, value, callback) => {
      console.log("🚀 ~ file: nutritionDetail.vue:250 ~ validatePass2 ~ value:", value)
      if (!value) {
        callback(new Error('请选择附件类型'));
      } else {
        callback();
      }
    };
    var validateCoaNo = (rule, value, callback) => {
      if (!value) {
        this.$msg.error(' 请输入COA NO.')
        return callback(new Error(' '));
      } else {
        callback();
      }
    };

    return {
      basicForm: {

      },
      categoryList2: [],
      categoryList3: [],
      typeLists: [],
      detailForm: {
        currentDetailList: [],
        tableHeaderList: [],
      },
      historyWindowDetailList: [],
      changeVersionList: [],
      operationLogList: [],
      fileTableData: [],
      dialogUploadFileVisible: false,
      dialogVisible: false,
      isCDisabled: false,
      isCLoading: false,
      isSaDisabled: false,
      isSaLoading: false,
      isSubDisabled: false,
      isSubLoading: false,
      updateForm: {
        updateReason: "",
      },
      fileForm: {
        files: '',
        seq: "",
        attachmentTypeText: "",
      },
      filesRules: {
        files: [
          { required: true, message: '请上传文件', trigger: 'blur' },
        ],
        seq: [
          { validator: validatePass2, trigger: 'change' },
        ],
      },
      fileLists: [],
      editForm: {},//变更信息
      rules: {},
      isDisabled: false,
      isSubmit: false,
      isEdit: true,
      rules: {
        coaNo: [
          { required: true, validator: validateCoaNo, trigger: 'blur' },
        ],
      }
    }
  },
  mounted() {
    this.getInfo(this.$route.query.id)
    this.getCategory1()
    // this.getCategory3()
    this.getInputChoiceValues()
    if (this.$route.query.type === 'view') {
      this.isDisabled = true
    } else {
      this.isDisabled = false
    }
  },
  methods: {
    getInfo(id) {
      nutriApi.getNutritionDetail(id, 'Y').then(res => {
        console.log("🚀 ~ file: nutritionDetail.vue:309 ~ nutriApi.getNutritionDetail ~ res:", res)
        if (res.code == '200') {
          this.$nextTick(() => {
            this.basicForm = res.data
            console.log("🚀 ~ file: nutritionDetail.vue:362 ~ nutriApi.getNutritionDetail ~ this.basicForm:", this.basicForm)
            this.detailForm.tableHeaderList = res.data.tableHeaderList
            this.detailForm.currentDetailList = res.data.currentDetailList
            this.historyWindowDetailList = res.data.historyWindowDetailList
            this.changeVersionList = res.data.changeVersionList
            this.operationLogList = res.data.operationLogList
            this.fileTableData = res.data.attachmentList
            var permission = JSON.parse(localStorage.getItem('ms_Permission'))
            console.log("🚀 ~ file: nutritionDetection.vue:412 ~ mounted ~ permission:", permission)
            // lab已上传检测结果也可以提交,弹出备注框
            if ((permission.indexOf('NUTRITION_LAB_AUDIT') != -1 && (this.basicForm.inspectStatus === 'Released' || this.basicForm.inspectStatus === 'Uploaded')) || (permission.indexOf('NUTRITION_CQS_OWNER_AUDIT') != -1 && (this.basicForm.inspectStatus === 'Uploaded' || this.basicForm.inspectStatus === 'Finalized'))) {
              this.isSubmit = true
            } else {
              this.isSubmit = false
            }
            if ((permission.indexOf('NUTRITION_LAB_AUDIT') != -1) && this.basicForm.inspectStatus === 'Released') {
              this.isEdit = true
            } else {
              this.isEdit = false
            }
            console.log('this.isDisabled', this.isDisabled)
            console.log('id是否相等', this.basicForm.latestInspectId == this.basicForm.inspectId)

          })
        }
      })
    },
    getCategory1() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
        var pid
        res.data.forEach(ele => {
          if (ele.code == '10' && ele.name == 'Food') {
            pid = ele.tmCategoryId
          }
        })
        this.getCategory2(pid)
      });
    },
    getCategory2(pid) {
      apiService.findCategory({ categoryLevel: 2, pid: pid }).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:507 ~ apiService.findCategory ~ res:", res)
        this.categoryList2 = res.data;
        this.getCategory3()
      });
    },
    getCategory3() {
      this.categoryList3 = []
      var pidList = []
      this.categoryList2.forEach(ele => {
        if (ele.code == this.basicForm.categoryLevel2Code) {
          pidList.push(ele.tmCategoryId)
        }
      })
      apiService.findCategory({ categoryLevel: 3, pidList: pidList }).then((res) => {
        console.log("🚀 ~ file: nutritionDetail.vue:325 ~ apiService.findCategory ~ res:", res)
        this.categoryList3 = res.data;
      });
    },
    getInputChoiceValues() {
      inputChoiceService.listInputChoice().then((res) => {
        console.log("🚀 ~ file: nutritionDetail.vue:338 ~ inputChoiceService.listInputChoice ~ res:", res)
        this.typeLists = res.data.filter(ele => {
          return ele.fieldName === 'ATTACHMENT_TYPE' && ele.tableName === 'TT_NUTR_INSPECT'
        })
        console.log("🚀 ~ file: nutritionDetail.vue:341 ~ inputChoiceService.listInputChoice ~ this.typeLists:", this.typeLists)
      });
    },
    onSaveClick() {
      var obj = Object.assign({}, this.basicForm)
      obj.tableHeaderList = this.detailForm.tableHeaderList
      obj.currentDetailList = this.detailForm.currentDetailList
      obj.operationLogList = this.operationLogList
      obj.historyWindowDetailList = this.historyWindowDetailList
      obj.changeVersionList = this.changeVersionList
      obj.attachmentList = this.fileTableData
      this.isSaDisabled = true
      this.isSaLoading = true
      nutriApi.inspectSave(obj).then(res => {
        console.log("🚀 ~ file: nutritionDetail.vue:458 ~ nutriApi.inspectSave ~ res:", res)
        this.isSaDisabled = false
        this.isSaLoading = false
        if (res.code == '200') {
          this.$message.success('保存成功')
          // this.$router.go(-1)
          this.getInfo(res.data.inspectId)
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        this.isSaDisabled = false
        this.isSaLoading = false
      })
    },
    onSubmit() {
      this.$refs['basicForm'].validate((valid1) => {
        if (valid1) {
          this.$refs['detailForm'].validate((valid) => {
            if (valid) {
              if (this.fileTableData.length === 0) {
                this.$message.error('请上传附件')
                return false
              }
              var name1 = this.typeLists.filter(ele => {
                return ele.code == 'INSPECT_ATTACHMENT_TYPE_002'
              })[0].chineseValue
              console.log("🚀 ~ file: nutritionDetail.vue:350 ~ name1 ~ name1:", name1)

              var name2 = this.typeLists.filter(ele => {
                return ele.code == 'INSPECT_ATTACHMENT_TYPE_001'
              })[0].chineseValue
              console.log("🚀 ~ file: nutritionDetail.vue:354 ~ name2 ~ name2:", name2)

              var isFlag = this.fileTableData.some(ele => {
                return ele.seq === 'INSPECT_ATTACHMENT_TYPE_002'
              })
              if (!isFlag) {
                this.$message.error('产品编码' + this.basicForm.fiveBitCode + '未上传Nutrition类型' + name1 + '的附件，请检查！')
                return false
              }
              var isFlag1 = this.fileTableData.some(ele => {
                return ele.seq === 'INSPECT_ATTACHMENT_TYPE_001'
              })
              if (!isFlag1) {
                this.$message.error('产品编码' + this.basicForm.fiveBitCode + '未上传Nutrition类型' + name2 + '的附件，请检查！')
                return false
              }
              // CQS Owner提交时，需填写修改备注
              var permission = JSON.parse(localStorage.getItem('ms_Permission'))
              if ((permission.indexOf('NUTRITION_CQS_OWNER_AUDIT') != -1 || permission.indexOf('NUTRITION_LAB_AUDIT') != -1) && this.basicForm.inspectStatus === 'Uploaded') {
                this.dialogVisible = true
              } else {
                var obj = Object.assign({}, this.basicForm)
                obj.tableHeaderList = this.detailForm.tableHeaderList
                obj.currentDetailList = this.detailForm.currentDetailList
                obj.operationLogList = this.operationLogList
                obj.historyWindowDetailList = this.historyWindowDetailList
                obj.changeVersionList = this.changeVersionList
                obj.attachmentList = this.fileTableData
                this.isSubDisabled = true
                this.isSubLoading = true
                nutriApi.inspectSubmit(obj).then(res => {
                  console.log("🚀 ~ file: nutritionDetail.vue:345 ~ nutriApi.inspectSubmit ~ res:", res)
                  this.isSubDisabled = false
                  this.isSubLoading = false
                  if (res.code == '200') {
                    this.$message.success('提交成功')
                    this.$router.go(-1)
                  } else if (res.code == '601') {
                    let str = res.msg;
                    str = str.replace(/\n/g, '<br>')
                    this.$confirm(str, {
                      // title: '导入错误信息',
                      // message: h('div', null, newArr),
                      showCancelButton: true,
                      confirmButtonText: '确认',
                      confirmButtonClass: "confirmButtonClass",
                      cancelButtonClass: "cancelButtonClass",
                      cancelButtonText: '取消',
                      customClass: "nutriUploadBtn",
                      type: 'warning'
                    }).then(() => {
                      obj.ignoreCheck = true
                      nutriApi.inspectSubmit(obj).then(res => {
                        if (res.code == '200') {
                          this.$message.success('提交成功')
                          this.$router.go(-1)
                        }
                      })
                    }).catch(() => {
                      this.$message.info('已取消')
                    })
                  } else {
                    this.$message.error(res.msg)
                  }
                }).catch(error => {
                  this.isSubDisabled = false
                  this.isSubLoading = false
                })
              }
            }
          })
        }
      })
    },
    onSave() {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          var obj = Object.assign({}, this.basicForm)
          obj.tableHeaderList = this.detailForm.tableHeaderList
          obj.currentDetailList = this.detailForm.currentDetailList
          obj.operationLogList = this.operationLogList
          obj.historyWindowDetailList = this.historyWindowDetailList
          obj.changeVersionList = this.changeVersionList
          obj.attachmentList = this.fileTableData
          obj.updateReason = this.updateForm.updateReason
          this.isCDisabled = true
          this.isCLoading = true
          nutriApi.inspectSubmit(obj).then(res => {
            console.log("🚀 ~ file: nutritionDetail.vue:345 ~ nutriApi.inspectSubmit ~ res:", res)
            this.isCDisabled = false
            this.isCLoading = false
            if (res.code == '200') {
              this.$message.success('提交成功')
              this.dialogVisible = false
              this.$router.go(-1)
            } else if (res.code == '601') {
              let str = res.msg;
              str = str.replace(/\n/g, '<br>')
              this.$confirm(str, {
                // title: '导入错误信息',
                // message: h('div', null, newArr),
                showCancelButton: true,
                confirmButtonText: '确认',
                confirmButtonClass: "confirmButtonClass",
                cancelButtonClass: "cancelButtonClass",
                cancelButtonText: '取消',
                customClass: "nutriUploadBtn",
                type: 'warning'
              }).then(() => {
                obj.ignoreCheck = true
                nutriApi.inspectSubmit(obj).then(res => {
                  if (res.code == '200') {
                    this.$message.success('提交成功')
                    this.dialogVisible = false
                    this.$router.go(-1)
                  }
                })
              }).catch(() => {
                this.$message.info('已取消')
              })
            } else {
              this.$message.error(res.msg)
            }
          }).catch(error => {
            this.isCDisabled = false
            this.isCLoading = false
          })
        }
      })
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      // var prop1 = column.property + '_alertFlag'
      // if (row[prop1] === 'Y') {
      //   return 'nutritionRedClass'
      // }
    },
    cellClassName1({ row, column, rowIndex, columnIndex }) {
      var prop1 = column.property + '_versionAlertFlag'
      if (row[prop1] === 'Y') {
        return 'nutritionRedClass'
      }
    },
    onClose() {
      this.dialogVisible = false
      this.updateForm.updateReason = ''
    },
    propInput(row, prop, newVal) {
      // console.log("🚀 ~ file: nutritionDetail.vue:458 ~ propInput ~ e:", newVal)
      // console.log("🚀 ~ file: nutritionDetail.vue:458 ~ propInput ~ prop:", prop)
      // console.log("🚀 ~ file: nutritionDetail.vue:458 ~ propInput ~ row:", row)
      // 只允许输入数字和小数点
      newVal = newVal.replace(/[^\d\.]/g, "");
      // 只保留小数点后两位
      newVal = newVal.replace(/^\D*([0-9]+\.[0-9]{0,2}).*$/, "$1");
      row[prop] = newVal;
    },
    onEdit() {
      this.getInfo(this.basicForm.latestInspectId)
    },
    goToDetail(row) {
      console.log("🚀 ~ file: nutritionDetail.vue:562 ~ goToDetail ~ row:", row)
      this.getInfo(row.inspectId)
    },
    onUploadFile() {
      this.dialogUploadFileVisible = true
      this.fileForm.seq = ''
      this.fileForm.files = ''
      this.fileLists = []
    },
    onDownload(row) {
      fileService.downloadFile(row).then(res => {
        console.log('res', res)
      })
    },
    onDeleteFile(index, row) {
      this.$confirm('请确认是否删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fileTableData.splice(index, 1)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    httpRequest(param) {
      console.log("🚀 ~ file: nutritionDetail.vue:335 ~ httpRequest ~ param:", param)
      this.fileForm.files = param.file.name
      this.fileLists = []
      this.fileLists.push(param.file)
    },
    beforeUpload(file) {
      //计算文件的大小
      const isLt50M = file.size / 1024 / 1024 < 50; //这里做文件大小限制
      //如果大于50M
      if (!isLt50M) {
        this.$message({
          message: '上传文件大小不能超过 50MB!',
          type: 'info'
        });
        return false;
      }
    },
    uploadClick() {
      this.$refs['fileForm'].validate((valid) => {
        if (valid) {
          let formData = new FormData();
          this.fileLists.forEach((v) => {
            formData.append('file', v, v.name)
          })
          formData.append('seq', this.fileForm.seq)
          fileService.fileUpload(formData).then((res) => {
            console.log("🚀 ~ file: nutritionDetail.vue:346 ~ fileService.fileUpload ~ res:", res)
            if (res.code == '200') {
              this.$message.success('上传成功')
              this.dialogUploadFileVisible = false
              this.typeLists.forEach(ele => {
                if (ele.code == this.fileForm.seq) {
                  this.fileForm.attachmentTypeText = ele.chineseValue
                }
              })
              res.data.forEach(ele => {
                ele.seq = this.fileForm.seq
                ele.attachmentTypeText = this.fileForm.attachmentTypeText
                ele.canOperation = true
                this.fileTableData.push(ele)
              })
              this.$refs.upload.clearFiles()
            }
          }).catch((error) => {
            //文件上传失败
            this.$message.error('文件上传失败')
          });
        }
      })
    },
    onCloseUploadFile() {
      this.dialogUploadFileVisible = false
      this.fileForm.seq = ''
      this.fileForm.files = ''
      this.fileLists = []
    },
    renderHeader(h, { column, $index }, item) {
      if (item.required) {
        return h("span", [
          h("span", { class: "mandatory" }),
          h("span", column.label)
        ]);
      } else {
        return h("span", [
          h("span", column.label)
        ]);
      }
    },
    routerBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  border: 1px solid #eee;
  padding: 8px;
  margin-top: 10px;
}
.info_box_title {
  height: 30px;
}
.info_title {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
  float: left;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
  float: left;
}
/deep/.el-upload--text {
  width: 100% !important;
}
</style>
  